import React from 'react'
import MasterLayout from '../../../masterLayout/MasterLayout'

export default function StudentPayments() {
  return (
    <MasterLayout>

    <div>StudentPayments</div>
    </MasterLayout>
  )
}
